<template>
  <div>
    <!-- 微信公众号弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="微信公众号设置"
      :visible.sync="wxDialogVisible"
      :before-close="wxHandleClose"
      width="46.4%"
      center
      top="30vh"
    >
      
      <div class="titleWx">启用微信公众号设置(ps:如果要开启,保存后生效).微信公众平台服务器配置信息(配置成功后不可修改)</div>
      <div class="wxFrom">
        <el-form ref="form" :model="form" label-width="110px">
          <div class="itemOne">
            <el-form-item label="Url:">
              <el-input v-model="form.name" placeholder="--"></el-input>
              <el-button>复制</el-button>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="Token:">
              <el-input v-model="form.name" placeholder="--"></el-input>
              <el-button>复制</el-button>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="授权回调域名:">
              <el-input v-model="form.name" placeholder="--"></el-input>
              <el-button>复制</el-button>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="公众号名称:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="请输入公众号名称"></el-input>
            </el-form-item>
          </div>
          <div class="itemTwo">
            <el-form-item label="公众号原始id:">
              <span class="xingB">*</span>
              <el-input v-model="form.name" placeholder="请输入原始id"></el-input>
              <span class="wenzi">
                <span>注:</span>
                <span>请认真填写,错了不能修改,如: cs_12ct5c</span>
              </span>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="微信号:">
              <span class="xingC">*</span>
              <el-input v-model="form.name" placeholder="请输入微信号"></el-input>
              <span class="wenzi">
                <span>如:</span>
                <span>misty</span>
              </span>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="AppID(公众号):">
              <span class="xingD">*</span>
              <el-input v-model="form.name" placeholder="请输入AppID(公众号)"></el-input>
              <span class="wenzi">
                <span>注:</span>
                <span>用于自定义菜单等高级功能</span>
              </span>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="AppSecret:">
              <span class="xingE">*</span>
              <el-input v-model="form.name" placeholder="请输入AppSecret"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <div class="btn">
              <el-button>清空</el-button>
              <el-button class="btnL">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 微信公众号弹框结束 -->
    <!-- 应用接口弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="应用接口详情"
      :visible.sync="interVisible"
      :before-close="interHandleClose"
      width="46.8%"
      center
      top="15vh"
    >
      

      <div class="interFrom">
        <el-form ref="form" :model="form" label-width="110px">
          <div class="itemOne">
            <el-form-item label="应用名称:">
              <el-input v-model="item.apiname" placeholder="--" disabled></el-input>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="AppID:">
              <el-input v-model="item.appid" placeholder="--"></el-input>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="softyktsecrect:">
              <el-input v-model="item.diskey" placeholder="--" type="password" show-password></el-input>
              <!-- <el-button>查看</el-button> -->
              <el-button @click="suiji('1')">随机获取</el-button>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="token:">
              <el-input v-model="item.token" placeholder="--"></el-input>
              <el-button @click="suiji('2')">随机获取</el-button>
            </el-form-item>
          </div>
          <div class="itemOne">
            <el-form-item label="回调url:">
              <el-input v-model="item.againurl" placeholder="--"></el-input>
              <el-button>验证</el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <div class="btn">
              <el-button  @click="interHandleClose">返回</el-button>
              <el-button class="btnL"  @click="setYyongjk">设置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 应用接口弹框结束 -->
    <!-- 创建应用接口弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="创建应用接口"
      :visible.sync="estInterVisible"
      :before-close="estInterHandleClose"
      width="27%"
      center
      top="30vh"
    >
      

      <div class="estinterFrom">
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="应用名称:">
            <span>*</span>
            <el-input v-model="yingName" placeholder="请输入应用名称"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="btn">
              <el-button class="btnL" @click="chuangjian">创建</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 创建应用接口弹框结束 -->
    <!-- 结算设置弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="创建应用接口"
      :visible.sync="maySetVisible"
      :before-close="maySetHandleClose"
      width="29.6%"
      center
      top="15vh"
    >
      

      <div class="maySetFrom">
        <el-form ref="form" :model="form" label-width="130px">
          <div class="itemOne">
            <el-form-item label="结算周期不能低于:">
              <el-input v-model="form.name" placeholder="数量"></el-input>
              <span>天</span>
            </el-form-item>
            <el-form-item label="结算金额不能低于:">
              <el-input v-model="form.name" placeholder="数量"></el-input>
              <span>元</span>
            </el-form-item>
          </div>
          <el-form-item label="销售方名称:">
            <el-input v-model="form.name" placeholder="输入销售方名称"></el-input>
          </el-form-item>
          <el-form-item label="开户名称:">
            <el-input v-model="form.name" placeholder="输入开户名称"></el-input>
          </el-form-item>
          <el-form-item label="开户行:">
            <el-input v-model="form.name" placeholder="输入开户行"></el-input>
          </el-form-item>
          <el-form-item label="结算联系人姓名:">
            <el-input v-model="form.name" placeholder="输入结算联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="结算联系人手机号:">
            <el-input v-model="form.name" placeholder="输入结算联系人手机号"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="btn">
              <el-button>清空</el-button>
              <el-button class="btnL">确认配置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 结算设置弹框结束 -->
  </div>
</template>

<script>
import {setApiAccount,ScenicPortSet} from '@/request/scenic.js'
import { Message } from 'element-ui';
export default {
  data() {
    return {
      wxDialogVisible: false, // 微信公众号
      interVisible: false, // 应用接口
      estInterVisible: false, // 创建应用接口
      maySetVisible: false, // 结算设置
      form: {
        name: ""
      },
      item:'',
      yingName:''
    };
  },
  methods: {
    chuangjian(){
      if(this.apinamen==''){
        Message.error('应用名称为空')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        apinamen:this.yingName
      }
      ScenicPortSet(data).then(res=>{
        if(res.data.status=='ok'){
          this.$emit('clos')
          this.estInterVisible = false
          this.yingName = ''
          Message.success('添加成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    suiji(i){
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      let num = ''
      for (let i = 0; i < 32; i++) {
         num += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      if(i=='1'){
        this.item.diskey = num
      }else{
        this.item.token = num
      }
    },
    setYyongjk(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        appid:this.item.appid,
        softyktsecrect:this.item.diskey,
        notify_url:this.item.againurl
      }
      setApiAccount(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('修改成功')
          this.interVisible = false;
          this.$emit('interClose')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 应用接口详情
    qingkong(){
      this.item.diskey = ''
      this.item.againurl = ''
      this.item.token = ''
      this.item.appid = ''
    },
    // 结算设置
    maySet() {
      this.maySetVisible = true;
    },
    // 结算设置X
    maySetHandleClose() {
      this.maySetVisible = false;
    },
    // 创建应用接口
    estinterFn() {
      this.estInterVisible = true;
    },
    // 创建应用接口X
    estInterHandleClose() {
      this.estInterVisible = false;
    },
    // 应用接口
    interFn(item) {
      this.interVisible = true;
      this.item = item
    },
    // 应用接口
    interHandleClose() {
      this.interVisible = false;
      this.$emit('interClose')
    },
    // 微信公众号设置
    wxoffical() {
      this.wxDialogVisible = true;
    },
    // 微信公众号设置X
    wxHandleClose() {
      this.wxDialogVisible = false;
    }
  }
};
</script>

<style lang='less' scoped>
.maySetFrom {
  .el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .itemOne {
    .el-input {
      width: 376px;
    }
    span {
      margin-left: 5px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .el-input {
    width: 400px;
  }
}
.estinterFrom {
  .el-form-item {
    position: relative;
    margin-top: 20px;
  }
  span {
    position: absolute;
    top: 0px;
    left: -76px;
    color: #e74c3c;
  }
}
.interFrom {
  .el-input {
    width: 500px;
  }
  .el-button {
    width: 100px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    margin-left: 20px;
  }
}
.titleWx {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #e74c3c;
  margin-bottom: 20px;
  margin-top: 20px;
}
.wxFrom {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -90px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -104px;
    color: #e74c3c;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -64px;
    color: #e74c3c;
  }
  .xingD {
    position: absolute;
    top: 0px;
    left: -116px;
    color: #e74c3c;
  }
  .xingE {
    position: absolute;
    top: 0px;
    left: -91px;
    color: #e74c3c;
  }
  /deep/.el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    /* identical to box height */
    text-align: right;
    color: #666666;
  }
  .itemOne {
    .el-input {
      width: 600px;
    }
    .el-button {
      width: 100px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      text-align: center;
      color: #246deb;
      margin-left: 20px;
    }
    .wenzi {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #e74c3c;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
  }
  .itemTwo {
    .el-input {
      width: 397px;
    }
    .wenzi {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #e74c3c;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
  }
  .itemThree {
    .el-input {
      width: 504px;
    }
    .wenzi {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #e74c3c;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 20px;
    margin-left: -100px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.btn {
  // margin: 20px 100px 10px 0;
  margin-top: 20px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
</style>